export const environment = {
    production: false,
    firebase: {
      apiKey: "AIzaSyA2I0NoZUeJN4XT8oS-0RbUdfB5htgEzSY",
      authDomain: "carcardiac-obd.firebaseapp.com",
      databaseURL: "https://carcardiac-obd.firebaseio.com",
      projectId: "carcardiac-obd",
      storageBucket: "carcardiac-obd.appspot.com",
      messagingSenderId: "537384211932",
      appId: "1:537384211932:web:8bb0f25317e2437a"
    }
  };


// WEBPACK FOOTER //
// ./src/app/environment/environment.ts